import React from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { POST } from "@/constants/testIds";

/**
 * "Draft my ad for me" panel — a soft blue-wash promo above the title/
 * description fields. Copy intentionally avoids the "AI" word per the
 * founder rules; the sparkle icon is the only visual cue.
 */
export default function AiWriterSection({
  aiKeywords,
  setAiKeywords,
  aiMut,
  disabled,
}) {
  return (
    <div className="rounded-2xl bg-gradient-to-r from-[color:var(--brand-blue-wash)] to-white p-4 md:p-5 border border-[color:var(--brand-blue-wash)]">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="w-4 h-4 text-[color:var(--brand-orange)]" />
        <span className="font-display font-bold text-slate-800">Draft my ad for me</span>
        <span className="text-xs text-slate-500">— describe your item in a few words.</span>
      </div>
      <div className="flex flex-col md:flex-row gap-2">
        <input
          data-testid={POST.aiKeywords}
          value={aiKeywords}
          onChange={(e) => setAiKeywords(e.target.value)}
          placeholder="e.g. 3 bed 2 bath house Flat Bush Auckland"
          className="input flex-1"
        />
        <button
          type="button"
          data-testid={POST.aiWriteBtn}
          onClick={() => aiMut.mutate()}
          disabled={aiMut.isPending || disabled}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[color:var(--brand-blue)] hover:bg-[color:var(--brand-blue-hover)] text-white font-bold px-5 py-2.5 disabled:opacity-60 transition-colors"
        >
          {aiMut.isPending ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <Sparkles className="w-4 h-4" />
          )}{" "}
          Write it for me
        </button>
      </div>
    </div>
  );
}
